// extracted by mini-css-extract-plugin
export default {"outerContainer":"MyProfilePage_outerContainer__cR40+","subContainer":"MyProfilePage_subContainer__k5Mfa","formContainer":"MyProfilePage_formContainer__yeQxA"};